import CustomDateField from "components/CustomDateField";
import moment from "moment";
import {
  ResourceContextProvider,
  Datagrid,
  TextField,
  ReferenceField,
  FunctionField,
  Filter,
  DateInput,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import { SchoolIdSelected } from "utils/tools";
import UpdatedByField from "../../../components/UpdatedByField";
import React from "react";
import { PaddingDenseStyledList } from "../../../components/ListWrapper";
import CustomPagination from "../../../components/CustomPagination";

interface INotTakingReportTable {
  isCanceled?: boolean;
}

const NotTakingReportTable = ({ isCanceled }: INotTakingReportTable) => {
  const NotTakingFilter = (props: any) => {
    return (
      <Filter {...props}>
        <DateInput source="Date" label="Date" alwaysOn />
        <ReferenceInput
          source="BusScheduleId"
          label="Wave Name"
          filter={{
            SchoolId: Number(SchoolIdSelected()),
          }}
          reference="busSchedules"
          alwaysOn
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      </Filter>
    );
  };

  return (
    <ResourceContextProvider value="notTakingReports">
      <PaddingDenseStyledList
        basePath="/notTakingReports"
        actions={null}
        exporter={false}
        hasCreate={false}
        filters={<NotTakingFilter />}
        filterDefaultValues={{
          Date: `${moment().format("Y-MM-DD")}`,
        }}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
          IsCanceled: isCanceled
        }}
        sort={{ field: "date", order: "DESC" }}
        bulkActionButtons={false}
        title="Not Takings"
        pagination={<CustomPagination />}
      >
        <Datagrid>
          <ReferenceField
            source="studentId"
            label="Student"
            reference="students"
            link={false}
          >
            <FunctionField
              render={(record: any) => `${record.firstName} ${record.lastName}`}
            />
          </ReferenceField>
          <ReferenceField
            source="busSchedulePlanId"
            label="Wave Name"
            reference="busSchedulePlans"
            link={false}
          >
            <ReferenceField
              source="busScheduleId"
              reference="busSchedules"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </ReferenceField>
          <TextField source="routeName" emptyText="-" />
          <CustomDateField source="date" />

          {/* Conditionally show Updated By and Updated At column */}
          {/* Use array for Updated By and Updated At to separate each column */}
          {!isCanceled &&
            [
              <FunctionField
                label="Updated By"
                render={(record: any) => (
                  <>
                    {record.updatedBy === null ? (
                      "-"
                    ) : (
                      <UpdatedByField data={record.updatedBy} />
                    )}
                  </>
                )}
              />,
              <CustomDateField source="updatedAt" isDateTime />
            ]
          }

          {/* Conditionally show Canceled By and Canceled At column */}
          {/* Use array for Canceled By and Canceled At to separate each column */}
          {isCanceled &&
            [
              <FunctionField
                label="Canceled By"
                render={(record: any) => (
                  <>
                    {record.deletedBy === null ? (
                      "-"
                    ) : (
                      <UpdatedByField
                        data={record.deletedBy}
                        referenceSource="deletedBy.id"
                      />
                    )}
                  </>
                )}
              />,
              <CustomDateField label="Canceled At" source="deletedAt" isDateTime />
            ]
          }
        </Datagrid>
      </PaddingDenseStyledList>
    </ResourceContextProvider>
  );
};

export default NotTakingReportTable;
